// extracted by mini-css-extract-plugin
module.exports = {"left":"RegularBox_left__MY0DC","center":"RegularBox_center__q5FkP","right":"RegularBox_right__ZUodD"};